import { Grid, Heading } from '@design-systems/canvas-ui'
import TeamsHeaderButtons from '../TeamsHeaderButtons'

const TeamsListHeader = () => {
  return (
    <Grid.Container className="hc8-mb-6x" align="center">
      <Grid.Item size={{ xs: true }}>
        <Heading>Teams</Heading>
      </Grid.Item>
      <Grid.Item>
        <TeamsHeaderButtons />
      </Grid.Item>
    </Grid.Container>
  )
}

export default TeamsListHeader
